import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateObject } from 'src/app/models/common';
import { ActivatedRoute } from '@angular/router';
import { EapStudyReportsViewModalComponent } from './eap-study-reports-view-modal/eap-study-reports-view-modal.component';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';

@Component({
  selector: 'app-eap-study-reports',
  templateUrl: './eap-study-reports.component.html',
  styleUrls: ['./eap-study-reports.component.scss']
})
export class EapStudyReportsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  ApplicationID: string;
  studyreportsform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  staticformFields: any;
  typeOptions: any[] = [];
  StartDateO: DateObject
  EndDateO: DateObject;
  screenName:string = "";
  collapesedOrNot:boolean = false;
  constructor(
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: EAPDatashareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe,

  ) {
  }

  ngOnInit() {
      
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = this.commonService.getPagePermission("EAP07").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("EAP07").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.GetSummaryData();
           clearInterval(intervalId);
         }
       }, 1000);
   }

  
    this.getStaticFiledsData('SCR-020');
    this.GetScreenConfigControls('SCR-020');
    
    this.userType = this.userService.getUserType();
    
    this.studyreportsform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      PatientName: new UntypedFormControl(null),
      SubmittedDateFrom: new UntypedFormControl(null),
      SubmittedDateTo: new UntypedFormControl(null),
      EndDateO : new UntypedFormControl(null),
      StartDateO : new UntypedFormControl(null)

    });
 

    this.tempoperations = [
    ];
   
    this.GetDropDownsData();

  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if (this.userType == "E") {
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "Type",
              "tooltipField": "Type"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title",
              "tooltipField": "Title"
            },      
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr",
              "tooltipField": "Submitted Date"
            },
            {
              "headerName": "Status",
              "field": "Status",
              "tooltipField": "Status"
            }
          ];
        } else {
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "Type",
              "tooltipField": "Type"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title",
              "tooltipField": "Title"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr",
              "tooltipField": "Submitted Date"
            }
          ];
        }
      });
  }

  GetDropDownsData() {
    this.summaryService.masterData("api/EAPStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=").subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
      this.typeOptions = [{ label: "All", value: "", checked: true }].concat(this.typeOptions);
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  add() {
    let modalRef = this.modalService.open(EapStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.GetSummaryData();
    })
  }

  edit(RcordData:any) {
    let modalRef = this['self'].modalService.open(EapStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: "Edit",
      content: { id: RcordData['ID'], ApplicationID: RcordData.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  view(RcordData:any) {
    let modalRef = this['self'].modalService.open(EapStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: "View",
      content: { id: RcordData['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  delete(RcordData:any) {
    if (RcordData['SubmittedDateStr'] == null || RcordData['SubmittedDateStr'] == undefined || RcordData['SubmittedDateStr'] == "") {
      let id = RcordData['ID'];
      let stdyReport = RcordData['Title'];
      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content = { heading: 'Delete Study Report', custommessage: 'Are you sure you want to delete '   + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/EAPStudyreports/Delete?RecordID=' + id).subscribe(summary => {

            if (summary["Status"] == 0) {
              this['self'].commonService.SuccessBanner(this['self'].screenName +' deleted successfully');
              this['self'].GetSummaryData();
            }
            else {
              this['self'].commonService.ValidationBanner("Referenced record Can't be Deleted");

            }
          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Record Can't be deleted");
    }
  }

  GetSummaryData() {

    this.SearchClear();
    this.summaryService.getSummaryData("api/EAPStudyreports/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  getSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/EAPStudyreports/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add " + this.screenName,
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }
    let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add  " + this.screenName,
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }
    });

    this.setDef(this.tempoperations);

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  SearchClear() {
    this.studyreportsform.reset();
  }

  AdvanceSearch() {
    var formData = this.studyreportsform.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["SubmittedDateFrom"] != null && formData["SubmittedDateFrom"] != "" && formData["SubmittedDateFrom"] != 'Invalid Date') {
      formData["StartDateStr"] = this.datepipe.transform(formData["SubmittedDateFrom"], 'dd-MMM-yyyy');
      formData["StartDateO"] = this.Full_Start_Date;
    }
    if (formData["SubmittedDateTo"] != null && formData["SubmittedDateTo"] != "" && formData["SubmittedDateTo"] != 'Invalid Date') {
      formData["EndDateStr"] = this.datepipe.transform(formData["SubmittedDateTo"], 'dd-MMM-yyyy');
      formData["EndDateO"] = this.Full_End_Date;
    }
    formData["SubmittedDateFrom"] = null;
    formData["SubmittedDateTo"] = null;
    this.getSummarySearch(formData);
    
  }

  validateSearch() {
    let hasValue: Boolean = true;
    if (this.studyreportsform.controls["SubmittedDateTo"].value != null && this.studyreportsform.controls["SubmittedDateTo"].value != undefined && this.studyreportsform.controls["SubmittedDateTo"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["SubmittedDateFrom"].value != null && this.studyreportsform.controls["SubmittedDateFrom"].value != undefined && this.studyreportsform.controls["SubmittedDateFrom"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Type"].value != null && this.studyreportsform.controls["Type"].value != undefined && this.studyreportsform.controls["Type"].value != "") {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Title"].value != null && this.studyreportsform.controls["Title"].value != undefined && this.studyreportsform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }
  onRowDoubleClicked($event)
  {
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID,'', (ScreenData) => {
      this.screenName = ScreenData.NAME;
      this.GetSummaryData();
    });
  }
}

